<template>
  <div class="product-estimate-info-container">
    <span class="title-icon">
      <v-img
        :src="
          require(`@/assets/${whitelabel.images.insuranceEducationInfoIcon}`)
        "
        class="info-icon mr-2"
        contain
      />
    </span>
    <p>
      {{ message }}
    </p>
  </div>
</template>

<script>
  export default {
    name: 'ProductEstimateInfo',
    props: {
      message: {
        required: true,
        type: String,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .product-estimate-info-container {
    width: 100%;
    display: flex;
    align-items: center;

    p {
      margin: 0;
      font-size: 10px;
      font-weight: 400;
      line-height: 15px;
      margin-left: 5px;
    }
  }
</style>
